"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeGeekIcon = exports.VPgeekIcon = exports.IDgeekIcon = exports.ConfigeekIcon = exports.NFTgeekIcon = exports.UsergeekIcon = exports.CanistergeekIcon = void 0;
const React = __importStar(require("react"));
const icons_1 = __importDefault(require("@ant-design/icons"));
const CanistergeekIconSVG_1 = require("./CanistergeekIconSVG");
const ConfigeekIconSVG_1 = require("./ConfigeekIconSVG");
const NFTgeekIconSVG_1 = require("./NFTgeekIconSVG");
const UsergeekIconSVG_1 = require("./UsergeekIconSVG");
const IDgeekIconSVG_1 = require("./IDgeekIconSVG");
const VPgeekIconSVG_1 = require("./VPgeekIconSVG");
const StakegeekIconSVG_1 = require("./StakegeekIconSVG");
const CanistergeekIcon = () => React.createElement(Wrapper, { bgColor: "#c2c5aa" },
    React.createElement(icons_1.default, { component: CanistergeekIconSVG_1.CanistergeekIconSVG, style: { fontSize: 45, color: "#333d29" } }));
exports.CanistergeekIcon = CanistergeekIcon;
const UsergeekIcon = () => React.createElement(Wrapper, { bgColor: "#d5ae28" },
    React.createElement(icons_1.default, { component: UsergeekIconSVG_1.UsergeekIconSVG, style: { fontSize: 45, color: "#741719" } }));
exports.UsergeekIcon = UsergeekIcon;
const NFTgeekIcon = () => React.createElement(Wrapper, { bgColor: "#3d405b" },
    React.createElement(icons_1.default, { component: NFTgeekIconSVG_1.NFTgeekIconSVG, style: { fontSize: 45, color: "#ede0d4" } }));
exports.NFTgeekIcon = NFTgeekIcon;
const ConfigeekIcon = () => React.createElement(Wrapper, { bgColor: "#C0AD90" },
    React.createElement(icons_1.default, { component: ConfigeekIconSVG_1.ConfigeekIconSVG, style: { fontSize: 45, color: "#2B3541" } }));
exports.ConfigeekIcon = ConfigeekIcon;
const IDgeekIcon = () => React.createElement(Wrapper, { bgColor: "#363636" },
    React.createElement(icons_1.default, { component: IDgeekIconSVG_1.IDgeekIconSVG, style: { fontSize: 45, color: "#FFFFFF" } }));
exports.IDgeekIcon = IDgeekIcon;
const VPgeekIcon = () => React.createElement(Wrapper, { bgColor: "#014d64" },
    React.createElement(icons_1.default, { component: VPgeekIconSVG_1.VPgeekIconSVG, style: { fontSize: 45, color: "#FFFFFF" } }));
exports.VPgeekIcon = VPgeekIcon;
const StakeGeekIcon = () => React.createElement(Wrapper, { bgColor: "#8a8a5b" },
    React.createElement(icons_1.default, { component: StakegeekIconSVG_1.StakegeekIconSVG, style: { fontSize: 45, color: "#FFFFFF" } }));
exports.StakeGeekIcon = StakeGeekIcon;
const Wrapper = (props) => {
    return React.createElement("div", { style: { width: 70, height: 70, borderRadius: 35, backgroundColor: props.bgColor || "white", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto" } }, props.children);
};
